module.exports = __webpack_public_path__ + "img/CardImage10.6a43a53c.png";